import React, { useState } from "react"
import Popup from "component/popup/popup"
import IconsColor from "util/iconsColor"
import { agent } from "apiClient/api"
import { useSnackbar } from "context/snackbarContext"
import { buildCityStatusPayload, ConfigurationCity } from "./configurationCities"
import styles from "./configuration.module.scss"

type ChangeCityStatusPopupProps = {
    isOpen: boolean
    city: ConfigurationCity | null
    onCancel: () => void
    onSuccess: () => void
}

const ChangeCityStatusPopup: React.FC<ChangeCityStatusPopupProps> = ({ isOpen, city, onCancel, onSuccess }) => {
    const { showSuccess, showError } = useSnackbar()
    const [isSaving, setIsSaving] = useState(false)
    const isDeactivating = Boolean(city?.flag_active)
    const target = isDeactivating ? "Inactive" : "Active"

    const handleConfirm = async () => {
        if (!city) return
        setIsSaving(true)
        try {
            const response = await agent.UpsertCityAPI.put(buildCityStatusPayload(city))
            if (response?.status === true) {
                showSuccess(`City set as ${target.toLowerCase()}`)
                onSuccess()
                onCancel()
            } else {
                showError(response?.error?.message || "Failed to change city status")
            }
        } catch (err) {
            console.error("Change city status error", err)
            showError("Failed to change city status")
        } finally {
            setIsSaving(false)
        }
    }

    return (
        <Popup
            isOpen={isOpen}
            onClose={onCancel}
            title="Change City Status"
            size="medium"
            heightFiexd={true}
            secondaryButton={{ label: "Cancel", onClick: onCancel }}
            primaryButton={{ label: isSaving ? "Saving..." : target, onClick: handleConfirm, disabled: isSaving }}
            showCloseButton={false}
        >
            {city && (
                <div className={styles.confirmationContent}>
                    <IconsColor
                        iconName="warningSign"
                        width="80px"
                        height="80px"
                        fillColor="none"
                        strokeColor="#FF0000"
                    />
                    <p className={styles.confirmationText}>
                        {isDeactivating ? (
                            <>
                                This city may be referenced by existing records. Deactivating it will prevent future
                                selection but will not affect existing quotations, or historical data.
                            </>
                        ) : (
                            <>
                                Are you sure you want to change the status of <strong>{city.city_name}</strong> to{" "}
                                <strong>{target}</strong>?
                            </>
                        )}
                    </p>
                </div>
            )}
        </Popup>
    )
}

export default ChangeCityStatusPopup
